<template>
  <el-dialog 
    :title="title" 
    :visible.sync="dialogVisible" 
    width="400px"
    :before-close="handleClose"
    @open="handleDialogOpen">
    <el-form 
      :model="form" 
      :rules="formRules"
      ref="menuForm"
      label-width="80px">
      <el-form-item prop="name">
        <span slot="label"><span style="color: #f56c6c;">*</span>菜单名称</span>
        <el-input 
          v-model="form.name" 
          placeholder="请输入菜单名称">
        </el-input>
      </el-form-item>
      <el-form-item v-if="isSecondary" prop="modelId">
        <span slot="label"><span style="color: #f56c6c;">*</span>关联模型</span>
        <el-select 
          v-model="form.modelId" 
          placeholder="请选择关联模型"
          style="width: 100%">
          <el-option
            v-for="item in modelOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="菜单描述" prop="description">
        <el-input 
          type="textarea" 
          v-model="form.description" 
          placeholder="请输入菜单描述">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'MenuDialog',
  props: {
    visible: Boolean,
    title: String,
    form: Object,
    rules: Object,
    modelOptions: Array,
    isSecondary: Boolean
  },
  data() {
    return {
      formRules: {} // 初始为空，不触发验证
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  methods: {
    handleDialogOpen() {
      // 弹框打开时不设置验证规则
      this.formRules = {}
      this.$nextTick(() => {
        if (this.$refs.menuForm) {
          this.$refs.menuForm.clearValidate()
        }
      })
    },
    async handleSubmit() {
      // 点击确定时才设置验证规则并验证
      this.formRules = this.rules
      this.$nextTick(async () => {
        try {
          await this.$refs.menuForm.validate()
          this.$emit('submit')
        } catch (error) {
          // 验证失败
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.formRules = {} // 重置验证规则
      this.$nextTick(() => {
        if (this.$refs.menuForm) {
          this.$refs.menuForm.clearValidate()
        }
      })
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
/* 样式可以在这里添加其他需要的样式 */
</style>